import { useEffect } from 'react';

const upsertMeta = (selector, attrName, attrValue, content) => {
  if (!content) return;
  let element = document.querySelector(`${selector}[${attrName}="${attrValue}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrName, attrValue);
    document.head.appendChild(element);
  }
  element.content = content;
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

export const useSeo = ({
  title,
  description,
  canonical,
  url,
  ogImage,
  twitterImage,
  keywords,
  type = 'website',
}) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('meta', 'property', 'og:title', title);
      upsertMeta('meta', 'name', 'twitter:title', title);
    }

    if (description) {
      upsertMeta('meta', 'name', 'description', description);
      upsertMeta('meta', 'property', 'og:description', description);
      upsertMeta('meta', 'name', 'twitter:description', description);
    }

    if (keywords) {
      upsertMeta('meta', 'name', 'keywords', keywords);
    }

    if (canonical) {
      upsertLink('canonical', canonical);
      upsertMeta('meta', 'property', 'og:url', url || canonical);
    }

    if (url) {
      upsertMeta('meta', 'property', 'og:url', url);
    }

    if (ogImage) {
      upsertMeta('meta', 'property', 'og:image', ogImage);
    }

    if (twitterImage) {
      upsertMeta('meta', 'name', 'twitter:image', twitterImage);
    }

    upsertMeta('meta', 'property', 'og:type', type);
    upsertMeta('meta', 'name', 'twitter:card', 'summary_large_image');
  }, [title, description, canonical, url, ogImage, twitterImage, keywords, type]);
};
